import { useState } from "react";

const useApiStatus = () => {
  const [state, setState] = useState({
    loading: false,
    error: "",
    status: null,
  });

  const run = async (fn) => {
    setState({ loading: true, error: "", status: null });
    try {
      const response = await fn();
      setState({
        loading: false,
        error: "",
        status: response?.status || null,
      });
    } catch (err) {
      console.log(err, "err");
      setState({
        loading: false,
        error: err?.response?.data?.message || err.message,
        status: null,
      });
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  return [state, run];
};

export default useApiStatus;
